import { unfollowWebinarAction } from 'pages/Webinar/store'
import { connect } from 'react-redux'
import UI from './UI'

const mapDispatchToProps = dispatch => ({
  changeFollowState: _ => dispatch(unfollowWebinarAction())
})

export default connect(null, mapDispatchToProps)(UI)
